import Vue from 'vue'
import Router from 'vue-router'
import store from "./store";

Vue.use(Router)

const router= new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () =>  import("./components/ClubDashboard.vue")
    },
    {
      path:"/backoffice/login",
      name:"login",
      meta:{
        noauth:true
      },
      component:()=>import("./components/Login.vue")
    },
    {
      path: '/backoffice/players/register',
      name: 'register-player',
      component: () => import("./components/PlayerRegistration.vue")
    },
    {
      path: '/backoffice/players',
      name: 'player-list',
      component: () => import("./components/PlayerList.vue")
    },
    {
      path: '/backoffice/championships',
      name: 'championship-list',
      component: () => import("./components/ChampionshipList.vue")
    },
    {
      path: '/backoffice/championships/create',
      name: 'championship-creator',
      component: () => import("./components/ChampionshipEditor.vue")
    },
    {
      path: '/backoffice/championships/edit/:id',
      name: 'championship-editor',
      component: () => import("./components/ChampionshipEditor.vue")
    },
    {
      path:"/backoffice/:champ/team",
      name:"register-team",
      component:()=>import("./components/TeamRegistration.vue")
    },
    {
      path:"/backoffice/team/editor/:id",
      name:"team-editor",
      component:()=>import("./components/TeamRegistration.vue")
    },
    {
      path:"/backoffice/teams/:id?",
      name:"team-list",
      component:()=>import("./components/TeamList.vue")
    },
    {
      path:"/backoffice/clubs",
      name:"club-list",
      component:()=>import("./components/ClubList.vue")
    },
    {
      path:"/backoffice/clubs/edit/:id",
      name:"club-editor",
      component:()=>import("./components/ClubEditor.vue")
    },
    {
      path:"/backoffice/clubs/create",
      name:"club-creator",
      component:()=>import("./components/ClubEditor.vue")
    },
    {
      path:"/backoffice/championships/result/:id",
      name:"championship-results",
      component:()=>import("./components/Results.vue")
    },
    {
      path:"/backoffice/players/edit/:id",
      name:"player-editor",
      component:()=>import("./components/PlayerEditor.vue")
    },
    {
      path:"/backoffice/users/profile/update",
      name:"user-profile-update",
      component:()=>import("./components/ChangePassword.vue")
    },
    {
      path:"/frontoffice/players/search",
      name:"search-player",
      meta:{
        noauth:true
      },
      component:()=>import("./components/SearchRegistrationNumber.vue")
    }
  ]
});

router.beforeEach(async function(to,from,next){
  if(!store.state.config.meta.initComplete)
  {
    console.log("not initialized. Requesting init");
    try {
      await store.dispatch("config/tryRestoreIdentity");
    } catch (error) {
      console.log(error);
    }
  }
  if(!to.meta || !to.meta.noauth){
    if(store.state.config.identity.token && store.state.config.identity.username){
      next();
    }
    else
    {
      next({name:"login"});
    }
  }
  else{
    next();
  }
})

export default router;
